import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { http } from "../lib/api";

/** Fire-and-forget visit tracking on every route change. */
export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    http.post("/track", {
      path: location.pathname,
      referrer: document.referrer || "",
    }).catch(() => { /* silent */ });
  }, [location.pathname]);
  return null;
}
